export type CardInbox = 'retail' | 'shop' | 'both';
export type CardSortMode = 'smart' | 'newest' | 'oldest';

interface CardQueryParams extends Record<string, string | number | undefined> {
  inbox?: CardInbox;
  sort: CardSortMode;
  search?: string;
}

export function buildCardQueryParams(
  inbox: CardInbox | undefined,
  sort: CardSortMode = 'smart',
  search = '',
): CardQueryParams {
  const normalizedSearch = search.trim();

  return {
    inbox: normalizedSearch ? undefined : (inbox ?? 'retail'),
    sort,
    search: normalizedSearch || undefined,
  };
}
